<template>
  <div class="modal contact-modal">
    <div class="overlay" @click="$emit('closeContactModal')"></div>
    <div class="wrapper">
      <img class="close" @click="$emit('closeContactModal')" :src="closeIcon"/>
      <div class="container">
        <div>
          <div class="form-wrapper">
            <div class="form-fields">
              <div class="title">{{$t('Support')}}</div>
              <div class="form-fields-wrapper">
                <label>
                  <div class="desc">{{$t('Name')}}</div>
                  <input type="text" :placeholder="$t('Name')" v-model="name"/>
                </label>
                <label>
                  <div class="desc">{{$t('Surname')}}</div>
                  <input type="text" :placeholder="$t('Surname')" v-model="surname"/>
                </label>
                <label>
                  <div class="desc">{{$t('E-mail address')}}</div>
                  <input type="email" :placeholder="$t('E-mail address')" v-model="email"/>
                </label>
                <label>
                  <div class="desc">{{$t('Phone')}}</div>
                  <input type="tel" :placeholder="$t('Phone')" v-model="phone"/>
                </label>
                <label class="full">
                  <div class="desc">{{$t('Topic')}}</div>
                  <input type="text" :placeholder="$t('Topic')" v-model="topic"/>
                </label>
                <label class="full">
                  <div class="desc">{{$t('Message')}}</div>
                  <textarea :placeholder="$t('Message')" v-model="message"></textarea>
                </label>
                <button @click="submitForm" class="button button2">
                  <span>{{$t('Send')}}</span>
                </button>
                <transition name="slide">
                  <div v-if="$parent.error" class="error-desc desc red">{{$parent.error}}</div>
                </transition>
                <transition name="slide">
                  <div v-if="$parent.successMessage" class="error-desc desc green">{{$parent.successMessage}}</div>
                </transition>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'ContactModal',
  props: [],
  components: {
  },
  data: function() {
    return {
      name: '',
      surname: '',
      email: '',
      phone: '',
      topic: '',
      message: ''
    }
  },
  methods: {
    submitForm() {
      let data = {
        "name": this.name,
        "surname": this.surname,
        "email": this.email,
        "phone": this.phone,
        "topic": this.topic,
        "message": this.message
      }
      this.$emit('contactSubmit', data)
    }
  }
}
</script>